import { Navbar } from '@/components/layout/Navbar';
import { Card, CardHeader, CardContent, CardTitle } from '@/components/ui/card';

export default function EstadisticasPage() {
    return (
        <div className="min-h-screen bg-background flex flex-col">
            <Navbar />
            <div className="flex-1 container mx-auto p-4">
                <Card>
                    <CardHeader>
                        <CardTitle>Estadísticas</CardTitle>
                    </CardHeader>
                    <CardContent>
                        <p className="text-muted-foreground">Esta sección mostrará estadísticas del progreso y uso de la plataforma.</p>
                        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-6">
                            <div className="p-6 bg-primary/10 rounded-lg">
                                <h3 className="text-lg font-bold">Sesiones Completadas</h3>
                                <p className="text-3xl font-bold mt-2">0</p>
                            </div>
                            <div className="p-6 bg-secondary/10 rounded-lg">
                                <h3 className="text-lg font-bold">Preguntas Respondidas</h3>
                                <p className="text-3xl font-bold mt-2">0</p>
                            </div>
                            <div className="p-6 bg-accent/10 rounded-lg">
                                <h3 className="text-lg font-bold">Días Activos</h3>
                                <p className="text-3xl font-bold mt-2">0</p>
                            </div>
                        </div>
                    </CardContent>
                </Card>
            </div>
        </div>
    );
}
